export default class CustomFacetCalendar{
    
    constructor(element) {
        this._wrapper = element;
        this._start = this._wrapper.querySelector('.js-custom-facet-calendar-start');
        this._end = this._wrapper.querySelector('.js-custom-facet-calendar-end');
        this.bindEvents();
    }
    
    bindEvents(){
        document.addEventListener('facetwp-refresh', () => {
           let _facet = this._wrapper.querySelector('.facetwp-facet');
           let facetName = _facet.getAttribute('data-name');
           
           this._start.value = FWP.facets[facetName][0] ? FWP.facets[facetName][0].split("-").reverse().join("-") : '';
           this._end.value =  FWP.facets[facetName][1] ? FWP.facets[facetName][1].split("-").reverse().join("-") : '';
        });
    }
    
}